import React, { useState, useEffect, useContext } from 'react'
import { Form, Button, Input, message, Modal, Switch, Typography, Table, Popconfirm, InputNumber} from 'antd';
import {useFetch} from './../../../../utils/hooks/useFetch'
import { appContext } from "./../../../../AppContext";
import AddRaceSkillPointModal from './AddRaceSkillPointModal';
import TextEditorReadOnly from '../../../text/TextEditorReadOnly';
import TextEditor from '../../../text/TextEditor';
import { IsStormvloed } from '@utils';

const { Text } = Typography;

export default function RaceModal({isModalVisible, setIsModalVisible, refresh, record}){
    const layout = useFormLayout();
    const [doFetch, FetchOptions] = useFetch();
    const [appState] = useContext(appContext);
    const [newRecord, setNewRecord] = useState(record);
    const [isShowAddRaceSkillPointModalVisible, setIsShowAddRaceSkillPointModalVisible] = useState(false);
    const [newRaceSkillPoints, setNewRaceSkillPoints] = useState(record.raceSkillPoints)

    const [description, setDescription] = useState(record.description)
    const isStormvloed = IsStormvloed(appState.storyName)

    const [form] = Form.useForm()
    form.setFieldsValue(record)

    function handleOk() {
        setIsModalVisible(false);
    }

    function handleCancel() {
        setIsModalVisible(false);
    }

    useEffect(() => {
        setNewRecord(record);
        setNewRaceSkillPoints(record.raceSkillPoints);
        setDescription(record.description)
    }, [record])

    useEffect(() => {
        form.setFieldsValue(record)
    }, [form, record])

    const columns = [
        {
            title: 'Type',
            key: 'skillPointType',
            hidden: !isStormvloed,
            render: (record) => {

                const foundType = appState.skillPointTypes.find(_ => _.id === record.skillPointTypeId)
                return (<Text>
                  {foundType?.name}
                </Text>)
              }
        },
        {
          title: 'Amount',
          dataIndex: 'amount',
          key: 'amount',
        },
        {
          title: 'Action',
          key: 'action', 
          visible: false,
          render: (record) => {
            if(!appState.isSlOfStory) {
              return;
            }
            return(
              <Popconfirm title="Sure to delete?" onConfirm={() => onDeleteRaceSkillPoint(record)}>
               {/*eslint-disable-next-line*/}
                  <a>Delete</a>
              </Popconfirm>
          
          )
          }
        }
    ].filter(_ => !_.hidden)

    function onDeleteRaceSkillPoint(record) {
        const newList = newRaceSkillPoints.filter(_ => _.id !== record.id)
        setNewRaceSkillPoints(newList);
    }

    function handleChangeTextEditor(newContent) {
        setDescription(JSON.stringify(newContent))
    }

    return (
            <Modal 
                title={`Selected ${isStormvloed ? "race" : "world"} : ${record.name}`}  
                visible={isModalVisible} 
                onOk={handleOk} 
                onCancel={handleCancel}
                footer={null}
                width={"80%"}
            >
                <Form 
                    form={form}
                    {...layout}
                    name="basic"
                    layout="horizontal"
                    onFinish={onUpdate}
                    >

                    <Form.Item
                        label="Name"
                        name="name"
                        rules={[{required:true, message:"Name is needed"}]}
                    >
                        <Input name="name" disabled={!appState.isSlOfStory} />
                    </Form.Item>

                    <Form.Item
                        label="Description"
                        name="description"
                    >
                        {appState.isSlOfStory ? 
                            <TextEditor 
                                content={record.description}
                                onChange={handleChangeTextEditor}
                            /> :
                            <TextEditorReadOnly 
                                content={record.description}
                            />
                        }
                    </Form.Item>
                    {appState.isSlOfStory && <Form.Item
                        label="Is playable"
                        name="isPlayable"
                    >
                        <Switch  
                            name="isPlayable" 
                            checked={newRecord.isPlayable}
                            onChange={_ => setNewRecord({
                                ...record,
                                isPlayable: !newRecord.isPlayable
                            })}
                        />
                    </Form.Item>}
                    <Form.Item
                        label="Default Hp"
                        name="defaultHp"
                    >
                        <InputNumber name="defaultHp" disabled={!appState.isSlOfStory}/>
                    </Form.Item>

                    {isStormvloed && <Form.Item
                        label="Default Strength"
                        name="defaultPower"
                    >
                        <InputNumber name="defaultPower" disabled={!appState.isSlOfStory}/>
                    </Form.Item>}

                    <Form.Item
                        label="Default Mana"
                        name="defaultMana"
                    >
                        <InputNumber name="defaultMana" disabled={!appState.isSlOfStory} />
                    </Form.Item>

                    <Form.Item
                        label="Default Stamina"
                        name="defaultStamina"
                    >
                        <InputNumber name="defaultStamina" disabled={!appState.isSlOfStory}/>
                    </Form.Item>
                    
                    {!isStormvloed && <Form.Item
                        label="Default Ritual Points"
                        name="defaultRp"
                    >
                        <InputNumber name="defaultRp" disabled={!appState.isSlOfStory}/>
                    </Form.Item> }

                    <Form.Item                         
                        label="SkillPoints"
                        name="raceSkillPoints"
                        >
                    {appState.isSlOfStory && <Button onClick={() => setIsShowAddRaceSkillPointModalVisible(true)}>
                        {isStormvloed ? "Add Race skillpoints" : "Add world skillpoints"}
                    </Button> }
                    <Table 
                        columns={columns} 

                        dataSource={newRaceSkillPoints} 
                            onRow={(record, rowIndex) => {
                                return {
                                onClick: event => {}, // click row
                                onDoubleClick: event => {},// {onRowClick(record)}, // double click row
                                onContextMenu: event => {}, // right button click row
                                onMouseEnter: event => {}, // mouse enter row
                                onMouseLeave: event => {}, // mouse leave row
                                };
                            }}
                        />
                    </Form.Item>

                    {appState.isSlOfStory && <Form.Item >
                        <Button type="primary" htmlType="submit">
                        {isStormvloed ? "Update race" : "Update world"}
                        </Button>
                    </Form.Item> }

                </Form>

                <AddRaceSkillPointModal 
                    setNewRaceSkillPoints={setNewRaceSkillPoints}
                    newRaceSkillPoints={newRaceSkillPoints}
                    setIsModalVisible={setIsShowAddRaceSkillPointModalVisible}
                    isModalVisible={isShowAddRaceSkillPointModalVisible}
                />
            </Modal>
    )

    function onUpdate(values)
    {
        const url = `/api/Race/${appState.storyId}/AddOrUpdateRace`;
        const body = {
            ...record,
            description:description,
            isPlayable:newRecord.isPlayable,
            name:values.name,
            raceSkillPoints:newRaceSkillPoints,
            defaultHp:values.defaultHp,
            defaultPower: values.defaultPower,
            defaultMana: values.defaultMana,
            defaultStamina: values.defaultStamina,
            defaultRp: values.defaultRp
        }
        doFetch(url, FetchOptions.POST, body)
            .then((response) => onAddInventoryLoaded(response.isSuccess))

        function onAddInventoryLoaded(isSuccess) {
            if(isSuccess) {
                refresh()
                setIsModalVisible(false);
                return;
            } 

            message.error('Could not update Race');
        }
    }

    function useFormLayout()
    {
        return {
            hideRequiredMark: true,
            colon: false,
            layout:"inline"
        }
    }
}